<div class="loading">
  <h3 class="loading-text">Loading...</h3>
  <img class="loading-spinner" src="assets/loading.svg" alt="loading..." />
</div>
